import React from 'react';
import {deleteDoc, doc, updateDoc} from "firebase/firestore";
import db from "../firebase";
import EditCardModal from "./modals/editCardModal";

const Card = (props) => {

  const {statuses, card} = props

  const statusesNames = statuses.sort((a, b) => a.column - b.column)
	.map(el => el.name);
  const firstColumn = statusesNames[0];
  const lastColumn = statusesNames[statusesNames.length-1];

  const changeStatus = async (direction) => {
	const currentIndexStatus = statusesNames.indexOf(card.status)
	const newStatus = statusesNames[currentIndexStatus + direction]
	await updateDoc(doc(db, 'cards', card.id), {status: newStatus})
  }

  const changePriority = async (direction) => {
	await updateDoc(doc(db, 'cards', card.id), {priority: card.priority + direction})
  }

  const deleteCard = async () => {
	await deleteDoc(doc(db, 'cards', card.id))
  }

  return (
	<>
	  <div className="card mb-4 rounded-3 shadow p-3 mb-5 bg-body-tertiary rounded">
		<div className="card-body">
		  <h5 className="card-title">
			{card.title}
		  </h5>
		  <p className="card-text ">
			{card.description}
		  </p>
		  <div className="card-text border border-secondary-subtle d-flex justify-content-evenly shadow p-0 mb-2 bg-body-tertiary rounded">
			<button type="button" className="btn btn-link text-decoration-none"
					onClick={() => changePriority(-1)}
					disabled={0 === card.priority}
			>↓</button>
			Priority: {card.priority}
			<button type="button" className="btn btn-link text-decoration-none"
					onClick={() => changePriority(+1)}
					disabled={3 === card.priority}
			>↑</button>
		  </div>
		  <button type="button" className="btn btn-sm btn-outline-secondary left"
				  disabled={card.status === firstColumn}
				  onClick={() => changeStatus(-1)}
		  >
			<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
				 className="bi bi-caret-left-fill" viewBox="0 0 16 16">
			  <path
				d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z"/>
			</svg>
		  </button>
		  <EditCardModal statuses={statuses} card={card} key={card.id}/>
		  <button type="button" className="btn btn-sm btn-outline-danger delete"
		  onClick={() => deleteCard()}
		  >
			<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash3"
				 viewBox="0 0 16 16">
			  <path
				d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z"/>
			</svg>
		  </button>
		  <button type="button" className="btn btn-sm btn-outline-secondary right"
				  disabled={card.status === lastColumn}
				  onClick={() => changeStatus(+1)}
		  >
			<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
				 className="bi bi-caret-right-fill" viewBox="0 0 16 16">
			  <path
				d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
			</svg>
		  </button>
		</div>
	  </div>
	</>
  );
};

export default Card;
